import { CommonSliceType } from '../../../../types/slice';
import { toRichTextFromProp, toTextFromProp } from '../../fields/text';

export const titleSlice = ({ primary }) => ({
  type: CommonSliceType.SUBTITLE,
  value: toTextFromProp('title', primary),
});

export const subtitleSlice = ({ primary }) => ({
  type: CommonSliceType.SUBTITLE,
  value: toTextFromProp('subtitle', primary),
});

export const chapeauSlice = ({ primary }) => ({
  type: CommonSliceType.CHAPEAU,
  value: toTextFromProp('chapeau', primary),
});

export const headingSlice = ({ primary }) => ({
  type: CommonSliceType.HEADING,
  value: toTextFromProp('heading', primary),
});

export const textSlice = ({ primary }) => ({
  type: CommonSliceType.TEXT,
  body: toRichTextFromProp('txt', primary),
});
